(function (root, factory) {
  'use strict';
  var portions = factory();
  if (typeof module === 'object' && module.exports) module.exports = portions;
  else if (root) root.WTXFirstOrderPortions = portions;
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var LB_TO_KG = 0.45359237;
  var MAX_SAFE = Number.MAX_SAFE_INTEGER;
  var source = Object.freeze({
    title: 'Calorie Ranges for an Average Healthy Adult Dog in Ideal Body Condition',
    publisher: 'World Small Animal Veterinary Association',
    updated: '2020-07',
    verified: '2026-10-07',
    url: 'https://wsava.org/wp-content/uploads/2020/07/Calorie-Needs-for-Healthy-Adult-Dogs-updated-July-2020.pdf',
    columns: Object.freeze(['weightLb', 'dailyKcalLow', 'dailyKcalHigh']),
    method: 'Published pound-column values with linear interpolation between adjacent rows. No extrapolation.',
    scope: 'Shopping estimates for healthy adult dogs in ideal body condition with ordinary activity. Individual requirements vary. This does not establish nutritional adequacy or prescribe a diet.'
  });
  var table = Object.freeze([
    [4.4, 140, 177], [6.6, 190, 239], [8.8, 240, 297], [11, 280, 351],
    [13.2, 320, 403], [15.4, 360, 452], [17.6, 400, 499], [19.8, 440, 546],
    [22, 470, 590], [24.2, 510, 634], [26.4, 540, 677], [28.6, 580, 719],
    [30.8, 610, 760], [33, 640, 800], [35.2, 670, 840], [37.4, 700, 879],
    [39.6, 730, 918], [41.8, 760, 956], [44, 790, 993], [46.2, 820, 1030],
    [48.4, 850, 1067], [50.6, 880, 1103], [52.8, 910, 1139], [55, 940, 1174],
    [57.2, 970, 1209], [59.4, 1000, 1244], [61.6, 1020, 1278], [63.8, 1050, 1312],
    [66, 1080, 1346], [68.2, 1100, 1397], [70.4, 1130, 1413], [72.6, 1160, 1446],
    [74.8, 1180, 1478], [77, 1210, 1511], [79.2, 1240, 1543], [81.4, 1260, 1575],
    [83.6, 1290, 1607], [85.8, 1310, 1639], [88, 1340, 1670], [90.2, 1360, 1701],
    [92.4, 1390, 1732], [94.6, 1410, 1763], [96.8, 1440, 1794], [99, 1460, 1824],
    [101.2, 1480, 1855], [103.4, 1510, 1885], [105.6, 1530, 1915], [107.8, 1560, 1945]
  ].map(function (row) { return Object.freeze(row); }));

  function positive(value) {
    return typeof value === 'number' && Number.isFinite(value) && value > 0 && value <= MAX_SAFE;
  }

  function identifier(value) {
    return (typeof value === 'string' && value.trim().length > 0) ||
      (Number.isSafeInteger(value) && value > 0);
  }

  function empty(error) {
    return {
      dailyKcalLow: null, dailyKcalHigh: null,
      dailyOzLow: null, dailyOzHigh: null,
      coverageDaysLow: null, coverageDaysHigh: null,
      foodCostDayLow: null, foodCostDayHigh: null,
      totalCalories: null, totalLb: null, subtotal: null,
      error: error
    };
  }

  function rowAt(weightLb) {
    for (var i = 0; i < table.length; i += 1) {
      var row = table[i];
      if (weightLb === row[0]) return { low: row[1], high: row[2], interpolated: false };
      if (weightLb < row[0] && i > 0) {
        var previous = table[i - 1];
        var fraction = (weightLb - previous[0]) / (row[0] - previous[0]);
        return {
          low: previous[1] + fraction * (row[1] - previous[1]),
          high: previous[2] + fraction * (row[2] - previous[2]),
          interpolated: true
        };
      }
    }
    return null;
  }

  function energy(dogs) {
    if (!Array.isArray(dogs) || !dogs.length) return empty('invalid_dogs');
    var low = 0;
    var high = 0;
    var interpolated = false;
    for (var i = 0; i < dogs.length; i += 1) {
      var dog = dogs[i];
      if (!dog || typeof dog !== 'object') return empty('invalid_dogs');
      if (dog.stage !== 'adult' || dog.condition !== 'ideal' || dog.activity !== 'usual' ||
          (dog.health !== undefined && dog.health !== 'routine')) return empty('individual_guidance');
      if (!positive(dog.weightLb)) return empty('invalid_weight');
      if (dog.weightLb < table[0][0] || dog.weightLb > table[table.length - 1][0]) return empty('weight_out_of_range');
      var row = rowAt(dog.weightLb);
      if (!row) return empty('weight_out_of_range');
      low += row.low;
      high += row.high;
      interpolated = interpolated || row.interpolated;
      if (!positive(low) || !positive(high)) return empty('unsafe_total');
    }
    return { dailyKcalLow: low, dailyKcalHigh: high, interpolated: interpolated, error: null };
  }

  function estimate(input) {
    if (!input || typeof input !== 'object') return empty('invalid_input');
    var requirements = energy(input.dogs);
    if (requirements.error) return empty(requirements.error);
    if (!Array.isArray(input.lines) || !input.lines.length) return empty('invalid_lines');
    if (!Array.isArray(input.products)) return empty('invalid_products');
    var products = Object.create(null);
    for (var p = 0; p < input.products.length; p += 1) {
      var product = input.products[p];
      if (!product || !identifier(product.id) || Object.prototype.hasOwnProperty.call(products, String(product.id))) {
        return empty('invalid_products');
      }
      products[String(product.id)] = product;
    }
    var totalLb = 0;
    var totalCalories = 0;
    var subtotal = 0;
    for (var l = 0; l < input.lines.length; l += 1) {
      var line = input.lines[l];
      if (!line || !identifier(line.productId) || !positive(line.lb) ||
          !Number.isSafeInteger(line.quantity) || line.quantity < 1 ||
          !Number.isSafeInteger(line.price) || line.price < 0) return empty('invalid_lines');
      var matched = products[String(line.productId)];
      if (!matched || !positive(matched.kcalPerKg)) return empty('unknown_calories');
      var lineLb = line.lb * line.quantity;
      var lineCalories = lineLb * LB_TO_KG * matched.kcalPerKg;
      var linePrice = line.price * line.quantity;
      if (!positive(lineLb) || !positive(lineCalories) || !Number.isSafeInteger(linePrice)) return empty('unsafe_total');
      totalLb += lineLb;
      totalCalories += lineCalories;
      subtotal += linePrice;
      if (!positive(totalLb) || !positive(totalCalories) || !Number.isSafeInteger(subtotal)) return empty('unsafe_total');
    }
    var kcalPerLb = totalCalories / totalLb;
    var result = {
      dailyKcalLow: requirements.dailyKcalLow,
      dailyKcalHigh: requirements.dailyKcalHigh,
      dailyOzLow: requirements.dailyKcalLow / kcalPerLb * 16,
      dailyOzHigh: requirements.dailyKcalHigh / kcalPerLb * 16,
      coverageDaysLow: totalCalories / requirements.dailyKcalHigh,
      coverageDaysHigh: totalCalories / requirements.dailyKcalLow,
      foodCostDayLow: subtotal * requirements.dailyKcalLow / totalCalories,
      foodCostDayHigh: subtotal * requirements.dailyKcalHigh / totalCalories,
      totalCalories: totalCalories,
      totalLb: totalLb,
      subtotal: subtotal,
      interpolated: requirements.interpolated,
      error: null
    };
    var amounts = ['dailyOzLow', 'dailyOzHigh', 'coverageDaysLow', 'coverageDaysHigh'];
    if (amounts.some(function (key) { return !positive(result[key]); }) ||
        !Number.isFinite(result.foodCostDayLow) || result.foodCostDayLow < 0 || result.foodCostDayLow > MAX_SAFE ||
        !Number.isFinite(result.foodCostDayHigh) || result.foodCostDayHigh < 0 || result.foodCostDayHigh > MAX_SAFE) {
      return empty('unsafe_total');
    }
    return result;
  }

  return Object.freeze({
    estimate: estimate,
    energy: energy,
    source: source,
    table: table,
    lbToKg: LB_TO_KG,
    costUnit: 'cents per day'
  });
}));
